export default "__VITE_ASSET__4348092b__"